import React, { useState } from "react";
import closeIcon from "../../../../assets/icon/chatClose.svg";
import doubleArrow from "../../../../assets/icon/double-arrow-down.svg";
import columnSelectorIcon from "../../../../assets/icon/column-selector.svg";
import catalogWhiteIcon from "../../../../assets/inventory/catalog-white.svg";

import {
  Button,
  ButtonGroup,
  Col,
  Dropdown,
  DropdownToggle,
  Row,
} from "reactstrap";
import SearchButtons from "components/SearchButtons";
import ReactStrapTable from "components/reactStrapTable";
import Checkbox from "components/common/Fields/Checkbox";

const InvOptimizationLocateProduct = ({ closeButton }) => {
  const [showPatientsDetails, setShowPatientsDetails] = useState(false);
   const [tableData, setTableData] = useState(rowData);
        const [data, setData] = useState([]);
  const [rSelected, setRSelected] = useState("off");
  

  const columnData = [
    {
      dataField: "all",
      text: (
        <div className="d-flex justify-content-start align-items-center gap-2">
          <Checkbox />
          All
        </div>
      ),
      show: true,
      width: 50,
    },
    {
      dataField: "status",
      text: "Status",
      show: true,
      sort: true,
    },
    {
      dataField: "rating",
      text: "Rating",
      show: true,
      sort: true,
    },
    {
      dataField: "wholesaler",
      text: "Wholesaler",
      show: true,
      sort: true,
    },
    {
      dataField: "ndc",
      text: "NDC",
      show: true,
      sort: true,
    },
    {
      dataField: "manufacturer",
      text: "Manufacturer",
      show: true,
      sort: true,
    },
    {
      dataField: "packagesize",
      text: "Package Size",
      show: true,
      sort: true,
    },
    {
      dataField: "packageprice",
      text: "Package Price",
      show: true,
      sort: true,
    },
  ];

  const rowData = [
    {
      all: <Checkbox />,
      status: "In Stock",
      rating: "AB",
      wholesaler: "McKesson",
      ndc: "65162017550",
      manufacturer: "Amneal",
      packagesize: "500 EA/BTL",
      packageprice: "$ 24.95",
    },
    {
      all: <Checkbox />,
      status: "In Stock",
      rating: "AB",
      wholesaler: "Cardinal Health",
      ndc: "683802017605",
      manufacturer: "Zydus",
      packagesize: "500 EA/BTL",
      packageprice: "$ 23.75",
    },
    {
      all: <Checkbox />,
      status: "Low Stock",
      rating: "AB",
      wholesaler: "McKesson",
      ndc: "60505025350",
      manufacturer: "Apotex",
      packagesize: "500 EA/BTL",
      packageprice: "$ 25.50",
    },
    {
      all: <Checkbox />,
      status: "In Stock",
      rating: "AB",
      wholesaler: "McKesson",
      ndc: "00378005305",
      manufacturer: "Sun Pharma",
      packagesize: "500 EA/BTL",
      packageprice: "$ 45.75",
    },
    {
      all: <Checkbox />,
      status: "In Stock",
      rating: "AB",
      wholesaler: "Cardinal Health",
      ndc: "43547028805",
      manufacturer: "Mylan",
      packagesize: "500 EA/BTL",
      packageprice: "$ 26.15",
    },
    {
      all: <Checkbox />,
      status: "In Stock",
      rating: "AB",
      wholesaler: "Blupax",
      ndc: "57554037788",
      manufacturer: "Solco",
      packagesize: "500 EA/BTL",
      packageprice: "$ 22.95",
    },
    {
      all: <Checkbox />,
      status: "In Stock",
      rating: "AB",
      wholesaler: "McKesson",
      ndc: "1234567890",
      manufacturer: "Amneal",
      packagesize: "500 EA/BTL",
      packageprice: "$ 24.95",
    },
    {
      all: <Checkbox />,
      status: "In Stock",
      rating: "AB",
      wholesaler: "McKesson",
      ndc: "1234567890",
      manufacturer: "Amneal",
      packagesize: "500 EA/BTL",
      packageprice: "$ 24.95",
    },
  ];

  const toggleFilter = () => {
    setRSelected((prev) => (prev === "off" ? "on" : "off"));
  };

  return (
    <div
      style={{ paddingRight: "5px" }}
      className="smart-deal-container table-card scroll-table position-relative border-0 pt-0 rounded bg-white"
    >
      <div className="header-text pt-2 pb-1" style={{ width: "90vw" }}>
        <div>Locate Product</div>
        <div>
          <img
            className="cursor-pointer"
            onClick={closeButton}
            src={closeIcon}
          />
        </div>
      </div>
      <div style={{ width: "90vw", overflow: "auto" }}>
        <div className="border mb-2 mt-2 p-6 bg-white bx-shadow">
          <Row>
            <Col md={12}>
              <h3
                className="patient-demo"
                onClick={() => setShowPatientsDetails(!showPatientsDetails)}
              >
                Drug Details
                <span>
                  {showPatientsDetails ? (
                    <img
                      src={doubleArrow}
                      style={{
                        transform: "rotate(180deg)",
                        transition: "opacity 0.3s ease, transform 0.3s ease",
                        marginLeft:"12px",
                        verticalAlign:"middle"
                      }}
                    />
                  ) : (
                    <img
                      src={doubleArrow}
                      style={{ transition: "opacity 0.3s ease",marginLeft:"12px",
                        verticalAlign:"middle"

                      }}
                    />
                  )}
                </span>
              </h3>
              <Col sm={12} className="d-flex justify-content-between">
                <div>
                  <span class="pdetails">Wholesaler: </span>
                  <span className="patient-details">Anda</span>
                </div>

                <div>
                  <span className="pdetails purple-border-left ">
                    Drug Name:{" "}
                  </span>
                  <span className="patient-details">
                    Lisinopril 10 MG Tablet
                  </span>
                </div>

                <div>
                  <span className="pdetails purple-border-left ">
                    Order QTY:{" "}
                  </span>{" "}
                  <span className="patient-details">8 BTL</span>
                </div>
                <div>
                  <span className="pdetails purple-border-left ">
                    Manufacturer:{" "}
                  </span>
                  <span className="patient-details">Amneal</span>
                </div>
                <div>
                  <span className="pdetails purple-border-left">
                    Par Level:{" "}
                  </span>
                  <span className="patient-details">4000</span>
                </div>
              </Col>
            </Col>
          </Row>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginTop: "12px",
          }}
        >
          <div style={{ display: "flex", gap: "10px" }}>
            <div>
              <SearchButtons
                InSize={200}
                placeHolder={"Search by Drug Name"}
                data={data}
                setFilterData={setTableData}
              />
            </div>
            <div>
              <Dropdown isOpen={undefined} toggle={undefined}>
                <DropdownToggle className="clmn">
                  <img src={columnSelectorIcon} alt="not available" />
                  <span>
                    Columns{" "}
                    {/* {totalCount > 0 && (
                                    <div className="totalcount">{totalCount}</div>
                                  )} */}
                  </span>
                </DropdownToggle>
              </Dropdown>
            </div>
            <div className="d-flex justify-content-center align-items-center gap-2">
              <span className="f-16 font-weight-600">Filter</span>
              <ButtonGroup className="filter-btn-group">
                <Button
                  color="info"
                  outline
                  onClick={toggleFilter}
                  active={rSelected === "off"}
                >
                  OFF
                </Button>
                <Button
                  color="info"
                  outline
                  active={rSelected === "on"}
                  onClick={toggleFilter}
                >
                  ON
                </Button>
              </ButtonGroup>
            </div>
          </div>
          <div>
            <Button color="primary">
              {" "}
              <img src={catalogWhiteIcon} />
              Catalog
            </Button>
          </div>
        </div>
        <ReactStrapTable data={rowData} columns={columnData} greenRow={[3]} />
      </div>

      <div className="create-manual-footer p-3" style={{ width: "90vw" }}>
        <div>
          <Button color="primary" className="reset" onClick={closeButton}>
            Back
          </Button>
        </div>
        <div className="d-flex">
          <Button className="back-button" onClick={closeButton}>
            Submit
          </Button>
          <Button color="primary" onClick={closeButton}>
            Save and Close
          </Button>
        </div>
      </div>
    </div>
  );
};

export default InvOptimizationLocateProduct;
